<template>
  <div class="row">
    <div id="feed-item" class="col-md-8 offset-md-2">
      <div class="vote-div">
        <i class="fas fa-chevron-up" @click="upVote"></i>
        <p>{{ postScore }}</p>
        <i class="fas fa-chevron-down" @click="downVote"></i>
      </div>
      <div class="content-div">
        <router-link class="paper-title" :to="{path: '/paper/' + paper.id}" >
          {{paper.title}}
        </router-link>
        <p>{{paper.authors}}</p>
        <p>{{paper.abstract | truncate(240, '...')}}</p>
        <p v-if="annotationCount === 1">{{annotationCount}} annotation</p>
        <p v-if="annotationCount > 1">{{annotationCount}} annotations</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import { db } from '@/main';

export default {
  name: 'FeedItem',
  data() {
    return {
      scoreAdjustment: 0,
      annotationCount: 0,
    }
  },
  props: ['paper'],
  mounted() {
    this.getAnnotationCount();
  },
  methods: {
    getAnnotationCount() {
      var annotationCount = db.collection('paperAnnotations').doc(this.paper.id).collection('annotations').get().then(val => {
        this.annotationCount = val.size;
      });
    },
    upVote(){
      var paperRef = db.collection('papers').doc(this.paper.id);
      if (!this.paper.upVotes.includes(firebase.auth().currentUser.uid)) {
        this.scoreAdjustment = 1;
      }
      paperRef.set({
        upVotes: firebase.firestore.FieldValue.arrayUnion(firebase.auth().currentUser.uid)
      }, {
        merge: true
      })
      mixpanel.track("click", {"name": "up vote paper"})
    },
    downVote(){
      var paperRef = db.collection('papers').doc(this.paper.id);
      if (this.paper.upVotes.includes(firebase.auth().currentUser.uid) || this.scoreAdjustment === 1) {
        this.scoreAdjustment = -1;
      }
      paperRef.set({
        upVotes: firebase.firestore.FieldValue.arrayRemove(firebase.auth().currentUser.uid)
      }, {
        merge: true
      })
      mixpanel.track("click", {"name": "down vote paper"})
    },
  },
  computed: {
    postScore: function() {
      var positives = this.paper.upVotes.length;
      var negatives = this.paper.downVotes.length;
      return positives - negatives + this.scoreAdjustment;
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix;
    }
  }
}
</script>

<style>
#feed-item {
  border-top: 1px solid black;
  display: flex;
  flex-direction: 'row';
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 15px;
}

.vote-div {
  background-color: rgb(247, 248, 249);
  padding: 10px;
}

.content-div {
  text-align: left;
  padding: 10px;
}

.paper-title {
  font-size: 22px;
}
</style>